// extracted by mini-css-extract-plugin
export var brand = "_3w-9";
export var compact = "_3w-6";
export var extraSmall = "_3w-7";
export var icon = "_3w-0";
export var large = "_3w-4";
export var light = "_3w-1";
export var medium = "_3w-5";
export var outline = "_3w-b";
export var primaryDark = "_3w-a";
export var primaryLight = "_3w-8";
export var primaryModern = "_3w-c";
export var success = "_3w-2";
export var successSolid = "_3w-3";